const koboldPlayerSpritesheet = {
  "name": "koboldPlayerSpritesheet",
  "tileHeight": 128,
  "tileWidth": 128,
  "spacing": 0,
  "tileCount": 4,
  "columns": 2,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/koboldPlayerSpritesheet.png",
  "sprites": {
    "koboldPlayerHead": [0],
    "koboldPlayerBody-first": [3],
    "koboldPlayerBody": [1]
  }
}
export default koboldPlayerSpritesheet;
